import fetchLockingSystemProductsBySku from "@secureo/common/utils/commerceTools/graphql/queries/fetchLockingSystemProductsBySku"
import getLockingSystemComponentFromLockingSystemProduct from "../utils/getLockingSystemComponentFromLockingSystemProduct"
import getLockingSystemPricePortions, {
	getLockingSystemMsrpPricePortions,
} from "../utils/getLockingSystemPricePortions"
import setIsLoading from "../utils/setIsLoading"

import { DispatchLockingSystemReducer, LockingSystemReducerState } from ".."
import { LockingSystemPreviewProduct } from "@secureo/common/typings/LockingSystem"
import { ProviderContext } from "notistack"

type SetComponentLockingSystemProductPayload = Pick<
	LockingSystemReducerState,
	| "componentsByUuid"

	// Price
	| "singleNetPriceCents"
	| "singleGrossPriceCents"
	| "totalNetPriceCents"
	| "totalGrossPriceCents"

	// Msrp
	| "singleNetMsrpPriceCents"
	| "singleGrossMsrpPriceCents"
	| "totalNetMsrpPriceCents"
	| "totalGrossMsrpPriceCents"
>

export const setComponentLockingSystemProduct = async (
	accessToken: string,
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	uuid: string,
	lockingSystemPreviewProduct: LockingSystemPreviewProduct,
	enqueueSnackbar: ProviderContext["enqueueSnackbar"],
) => {
	const { taxRate, componentsByUuid, quantity, locale, countryCode, lockingComponentsUuids } =
		reducerState
	const { sku, lockingSystemComponentType } = lockingSystemPreviewProduct

	setIsLoading(dispatch, true)

	const { name, quantity: componentQuantity } = componentsByUuid[uuid]

	const lockingSystemProductsBySku = await fetchLockingSystemProductsBySku(
		accessToken,
		[sku],
		locale,
		"EUR",
	)
	const lockingSystemProduct = lockingSystemProductsBySku?.[sku] ?? null
	const updatedComponent = getLockingSystemComponentFromLockingSystemProduct(
		lockingSystemProduct,
		lockingSystemComponentType,
		countryCode,
		taxRate,
		componentQuantity,
		name,
		uuid,
	)
	componentsByUuid[uuid] = updatedComponent

	const { singleNetPriceCents, singleGrossPriceCents, totalNetPriceCents, totalGrossPriceCents } =
		getLockingSystemPricePortions(componentsByUuid, quantity)

	const {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	} = getLockingSystemMsrpPricePortions(componentsByUuid, quantity)

	const payload: SetComponentLockingSystemProductPayload = {
		componentsByUuid,

		// Price
		singleNetPriceCents,
		singleGrossPriceCents,
		totalNetPriceCents,
		totalGrossPriceCents,

		// Msrp
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}

	dispatch({
		type: "SET_COMPONENT_PRODUCT",
		payload,
	})

	const lockingComponentIndex = lockingComponentsUuids.findIndex(
		(componentUuid) => componentUuid === uuid,
	)

	enqueueSnackbar(`Tür #${lockingComponentIndex + 1}: Konfigurationen für wurden zurückgesetzt`, {
		variant: "info",
	})

	setIsLoading(dispatch, false)
}
